<template>
   <div class="nav-buttons">
      <button 
         :class= "[
            btnClass,
            (this.type === 'primary') ? btnPrimClass : '',
            (this.type === 'secondary') ? btnSecndClass : ''
            ]"
         @click="goTo()"
         type="button"
      >
         {{ label }}
      </button>
   </div>
</template>

<script>
   import { mapStates, mapGetters, mapActions } from 'vuex'
   export default {
      props: {
         type: {
            //Identifies for styling what type of button it should be
            type: String,
            validator: function (value) {
               return ['primary', 'secondary'].indexOf(value) !== -1
            },
            required: true,
         },
         label: {
            //what is the label for the button
            type: String,
            required: true,
         },
      },
      data: function(){
         //data function holding the classes for ease of use
         return { 
            btnClass: 'btn-cta',
            btnPrimClass: 'btn-cta--red',
            btnSecndClass: 'btn-cta--light',
         }
      }, 
      computed: {
      },

      methods: {
         //handles the button click
         goTo(data){
            this.$emit('goTo', data);
         },
      }
   }
</script>

